import { render, staticRenderFns } from "./new_publish.vue?vue&type=template&id=ef342cf6&scoped=true&"
import script from "./new_publish.vue?vue&type=script&lang=js&"
export * from "./new_publish.vue?vue&type=script&lang=js&"
import style0 from "./new_publish.vue?vue&type=style&index=0&id=ef342cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef342cf6",
  null
  
)

export default component.exports